import api from './api';
import { Class, Student } from '../types';

export interface ClassName {
  id: number;
  name: string;
  order: number;
  created_at: string;
  updated_at: string;
}

class ClassService {
  async getClassNames(): Promise<ClassName[]> {
    const response = await api.get('/class-names/');
    // Handle both array and paginated response
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }

  async getClasses(): Promise<Class[]> {
    const response = await api.get('/classes/');
    // Handle both array and paginated response
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }

  async getClass(id: number): Promise<Class> {
    const response = await api.get<Class>(`/classes/${id}/`);
    return response.data;
  }

  async createClass(data: Partial<Class>): Promise<Class> {
    const response = await api.post<Class>('/classes/', data);
    return response.data;
  }

  async updateClass(id: number, data: Partial<Class>): Promise<Class> {
    const response = await api.put<Class>(`/classes/${id}/`, data);
    return response.data;
  }

  async deleteClass(id: number): Promise<void> {
    await api.delete(`/classes/${id}/`);
  }

  async getStudents(classId?: number): Promise<Student[]> {
    const params = classId ? { class_group: classId } : {};
    const response = await api.get('/students/', { params });
    // Handle both array and paginated response
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }

  async getStudent(id: number): Promise<Student> {
    const response = await api.get<Student>(`/students/${id}/`);
    return response.data;
  }

  async createStudent(data: Partial<Student>): Promise<Student> {
    const response = await api.post<Student>('/students/', data);
    return response.data;
  }

  async updateStudent(id: number, data: Partial<Student>): Promise<Student> {
    const response = await api.put<Student>(`/students/${id}/`, data);
    return response.data;
  }

  async deleteStudent(id: number): Promise<void> {
    await api.delete(`/students/${id}/`);
  }

  async bulkImportStudents(students: Partial<Student>[]): Promise<{ created: number; students: Student[] }> {
    const response = await api.post<{ created: number; students: Student[] }>('/students/bulk_import/', { students });
    return response.data;
  }
}

const classService = new ClassService();
export default classService;